<template>
  <printable-item-surface-print-article
    v-for="print in article.prints"
    :key="print.id"
    :print="print"
    :article="article"
    @show="show"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'
import { addLateDeliverySurcharge } from '@/utils/helper'

const store = useMainStore()

// Props
const props = defineProps({
    article: {
        type: Object,
        required: true,
    },
});

// Emits
const emit = defineEmits(['show'])

// Computes
const locale = computed(() => store.settings.locale)
const inEnglish = computed(() => {
  return locale.value === 'en'
})
const shoppingCart = computed(() => store.settings.shopping_cart)

const printArticles = computed(() => {
  return shoppingCart.value.print_items.filter((item) => {
    return item.parent_id === props.article.id
  })
})

// Methods
const show = (article) => {
  emit('show', article)
}
</script>